import React from 'react';

import { 
	func, 
} from 'prop-types';


export default class Container extends React.Component {
    static propTypes = {
    	render : func.isRequired,
    }
    render(){
    	const {render,...other} = this.props;
    	return render({
    	},other);
    }
}